import { DocumentalTypologyResult, 
// DocumentalValidation,
DocumentalValidationCode, } from '@isyc-react/types';
import { DocumentRequestStatus } from 'common/types';
const docValidationLineArchives = (docLine, statistics) => {
    var _a;
    return statistics.typologyAndDocuments ? (_a = statistics.typologyAndDocuments[docLine.documentTypeId]) !== null && _a !== void 0 ? _a : [] : [];
};
const docValidationLineResult = (docLine, statistics) => {
    var _a;
    return (_a = statistics.typologyResultMap[docLine.documentTypeId]) !== null && _a !== void 0 ? _a : null;
};
// TODO improve splitting logic between completed and pending or both ...
export const docGroupToCompletedAndPending = (doc, relatedId, relatedObjectTypeId, name) => {
    const res = {
        pending: [],
        completed: [],
    };
    doc.forEach(d => {
        if (d.documentalValidationLines.length > 0) {
            if (d.validation === DocumentalValidationCode.ANY) {
                const statistics = d.evaluationResults;
                const uploaded = d.documentalValidationLines.find(line => docValidationLineArchives(line, statistics).length > 0);
                const result = uploaded ? docValidationLineResult(uploaded, statistics) : null;
                const docReqId = d.pendingDocumentRequestIdList[0].id;
                if (!docReqId && uploaded && result && result !== DocumentalTypologyResult.TYPOLOGY_RESULT_INVALID) {
                    res.completed.push({
                        name: d.documentalGroupName + ' - ' + name,
                        docName: d.documentalGroupName,
                        objectName: name,
                        code: d.documentalGroupCode,
                        validation: d.validation,
                        requests: [
                            {
                                tId: uploaded.documentTypeId,
                                tName: uploaded.documentTypeName,
                                tCode: uploaded.documentTypeCode,
                                status: uploaded.status,
                                result,
                                documentsEdm: docValidationLineArchives(uploaded, statistics),
                            },
                        ],
                    });
                }
                else {
                    res.pending.push({
                        name: d.documentalGroupName + ' - ' + name,
                        docName: d.documentalGroupName,
                        objectName: name,
                        code: d.documentalGroupCode,
                        relatedId: d.consideredId ? d.consideredId : d.relatedId,
                        relatedObjectTypeId: d.consideredObjectTypeId ? d.consideredObjectTypeId : d.relatedObjectTypeId,
                        validation: d.validation,
                        requests: [
                            {
                                tId: 0,
                                tName: d.documentalGroupName,
                                tCode: d.documentalGroupCode,
                                tFormatList: [],
                                docReqId,
                                options: d.documentalValidationLines.map(line => (Object.assign({}, line))),
                            },
                        ],
                    });
                }
            }
            else {
                const pendingReq = [];
                const completedReq = [];
                const statistics = d.evaluationResults;
                const filterLines = d.documentalValidationLines.filter(l => l.pendingDocumentRequestIdList.length > 0);
                filterLines.forEach(dv => {
                    const docReqId = dv.pendingDocumentRequestIdList[0].id;
                    const documentsEdm = docValidationLineArchives(dv, statistics);
                    const result = docValidationLineResult(dv, statistics);
                    if (documentsEdm.length === 0 ||
                        !result ||
                        result === DocumentalTypologyResult.TYPOLOGY_RESULT_INVALID ||
                        result === DocumentalTypologyResult.TYPOLOGY_RESULT_IN_PROGRESS) {
                        pendingReq.push({
                            tId: dv.documentTypeId,
                            tName: dv.documentTypeName,
                            tCode: dv.documentTypeCode,
                            tFormatList: dv.documentTypeFormatList,
                            docReqId,
                            options: [],
                        });
                    }
                    else {
                        completedReq.push({
                            tId: dv.documentTypeId,
                            tName: dv.documentTypeName,
                            tCode: dv.documentTypeCode,
                            status: dv.status,
                            result: result !== null && result !== void 0 ? result : DocumentalTypologyResult.TYPOLOGY_RESULT_NO_INFO,
                            documentsEdm: documentsEdm,
                        });
                    }
                });
                if (pendingReq.length > 0)
                    res.pending.push({
                        name: d.documentalGroupName + ' - ' + name,
                        docName: d.documentalGroupName,
                        objectName: name,
                        code: d.documentalGroupCode,
                        relatedId: d.consideredId ? d.consideredId : d.relatedId,
                        relatedObjectTypeId: d.consideredObjectTypeId ? d.consideredObjectTypeId : d.relatedObjectTypeId,
                        validation: d.validation,
                        requests: pendingReq,
                    });
                if (completedReq.length > 0)
                    res.completed.push({
                        name: d.documentalGroupName + ' - ' + name,
                        docName: d.documentalGroupName,
                        objectName: name,
                        code: d.documentalGroupCode,
                        validation: d.validation,
                        requests: completedReq,
                    });
            }
        }
    });
    return res;
};
export const docGroupToCompleted = (doc, relatedId, relatedObjectTypeId, name) => {
    const completed = [];
    doc.forEach(d => {
        if (d.documentalValidationLines.length > 0) {
            const statistics = d.evaluationResults;
            if (d.validation === DocumentalValidationCode.ANY) {
                const uploads = d.documentalValidationLines.filter(line => {
                    return docValidationLineArchives(line, statistics);
                });
                uploads.forEach((u, i) => {
                    const result = statistics.typologyResultMap[u.documentTypeId];
                    return completed.push({
                        name: d.documentalGroupName + ' - ' + name,
                        docName: d.documentalGroupName,
                        objectName: name,
                        code: d.documentalGroupCode,
                        validation: d.validation,
                        requests: [
                            {
                                tId: u.documentTypeId,
                                tName: u.documentTypeName,
                                tCode: u.documentTypeCode,
                                status: u.status,
                                result,
                                documentsEdm: docValidationLineArchives(u, statistics),
                            },
                        ],
                    });
                });
            }
            else {
                const filterLines = d.documentalValidationLines.filter(l => l.pendingDocumentRequestIdList.length > 0 &&
                    l.pendingDocumentRequestIdList.filter(pdril => pdril.status.toString() === DocumentRequestStatus.CANCELED_STATUS ||
                        pdril.status.toString() === DocumentRequestStatus.COMPLETED_STATUS).length > 0);
                const reqCompleted = [];
                filterLines.forEach(dvl => {
                    const documentsEdm = docValidationLineArchives(dvl, statistics);
                    const result = docValidationLineResult(dvl, statistics);
                    if (documentsEdm.length > 0) {
                        reqCompleted.push({
                            tId: dvl.documentTypeId,
                            tName: dvl.documentTypeName,
                            tCode: dvl.documentTypeCode,
                            status: dvl.status,
                            result: result !== null && result !== void 0 ? result : DocumentalTypologyResult.TYPOLOGY_RESULT_NO_INFO,
                            documentsEdm: documentsEdm,
                        });
                    }
                });
                if (reqCompleted.length > 0) {
                    completed.push({
                        name: d.documentalGroupName + ' - ' + name,
                        docName: d.documentalGroupName,
                        objectName: name,
                        code: d.documentalGroupCode,
                        validation: d.validation,
                        requests: reqCompleted,
                    });
                }
            }
        }
    });
    return completed;
};
export const docGroupToPending = (doc, relatedId, relatedObjectTypeId, name) => {
    const pending = [];
    doc.forEach(d => {
        if (d.documentalValidationLines.length > 0) {
            const statistics = d.evaluationResults;
            if (d.validation === DocumentalValidationCode.ANY) {
                const pendDocReqId = d.pendingDocumentRequestIdList.filter(p => p.status.toString() === DocumentRequestStatus.IN_PROGRESS_STATUS);
                pendDocReqId.forEach(p => {
                    pending.push({
                        name: d.documentalGroupName + ' - ' + name,
                        docName: d.documentalGroupName,
                        objectName: name,
                        code: d.documentalGroupCode,
                        relatedId: d.consideredId ? d.consideredId : d.relatedId,
                        relatedObjectTypeId: d.consideredObjectTypeId ? d.consideredObjectTypeId : d.relatedObjectTypeId,
                        validation: d.validation,
                        requests: [
                            {
                                tId: 0,
                                tName: d.documentalGroupName,
                                tCode: d.documentalGroupCode,
                                tFormatList: [],
                                docReqId: p.id,
                                options: d.documentalValidationLines.map(line => (Object.assign({}, line))),
                            },
                        ],
                    });
                });
            }
            else {
                const filterLines = d.documentalValidationLines.filter(l => l.pendingDocumentRequestIdList.length > 0 &&
                    l.pendingDocumentRequestIdList.filter(pdril => pdril.status.toString() === DocumentRequestStatus.IN_PROGRESS_STATUS).length > 0);
                const reqPending = [];
                filterLines.forEach(dvl => {
                    var _a;
                    const docReqId = (_a = dvl.pendingDocumentRequestIdList
                        .filter(pdril => pdril.status.toString() === DocumentRequestStatus.IN_PROGRESS_STATUS)
                        .find(pdril => pdril.documentTypeId === dvl.documentTypeId)) === null || _a === void 0 ? void 0 : _a.id;
                    const documentsEdm = docValidationLineArchives(dvl, statistics);
                    const result = docValidationLineResult(dvl, statistics);
                    if (documentsEdm.length === 0 ||
                        !result ||
                        result === DocumentalTypologyResult.TYPOLOGY_RESULT_INVALID ||
                        result === DocumentalTypologyResult.TYPOLOGY_RESULT_IN_PROGRESS) {
                        reqPending.push({
                            tId: dvl.documentTypeId,
                            tName: dvl.documentTypeName,
                            tCode: dvl.documentTypeCode,
                            tFormatList: dvl.documentTypeFormatList,
                            docReqId,
                            options: [],
                        });
                    }
                });
                if (reqPending.length > 0) {
                    pending.push({
                        name: d.documentalGroupName + ' - ' + name,
                        docName: d.documentalGroupName,
                        objectName: name,
                        code: d.documentalGroupCode,
                        relatedId: d.consideredId ? d.consideredId : d.relatedId,
                        relatedObjectTypeId: d.consideredObjectTypeId ? d.consideredObjectTypeId : d.relatedObjectTypeId,
                        validation: d.validation,
                        requests: reqPending,
                    });
                }
            }
        }
    });
    return pending;
};
